module.exports = __webpack_public_path__ + "assets/img/swiper-img2-50890844.png";